export default {"src":"/_next/static/media/chevron_right.fe05459e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};